import { formatNumber } from '@/modules/utils/phoneNumber';
import {
  CTA,
  Text,
  TextProps,
  TextTag,
} from '@volkswagen-onehub/components-core';
import { CTACommonProps } from '@volkswagen-onehub/components-core/dist/call-to-action';
import { type ReactNode } from 'react';

interface CTATelProps {
  tel: string;
  children?: ReactNode;
  textProps?: Omit<TextProps, 'tag'>;
  ctaProps?: Omit<CTACommonProps, 'tag'>;
  onClick?: () => void;
}

const CTATel = ({
  tel,
  children,
  textProps,
  ctaProps,
  onClick,
}: CTATelProps) => (
  <CTA
    emphasis="tertiary"
    {...ctaProps}
    tag="a"
    href={`tel: ${formatNumber(tel)}`}
    onClick={onClick}
  >
    <Text tag={TextTag.span} bold {...textProps}>
      {children || formatNumber(tel)}
    </Text>
  </CTA>
);

export default CTATel;
